<template>
  <div>
    <router-view ></router-view>
    <!-- <router-view :key="$route.fullPath"></router-view> -->
    <!-- Global Video Modal - available throughout the app -->
    <VideoModal />
  </div>
</template>

<script>
import VideoModal from "@/components/Signup/VideoModal.vue";

export default {
  components: {
    VideoModal
  }
}
</script>
<style>
@media not all and (min-resolution:.001dpcm) {
  @supports (-webkit-appearance:none) {
    body {
      font-weight: 400 !important;
      -webkit-font-smoothing: antialiased;
    }
  }
}




</style>
